import { GetterTree } from "vuex";
import { ILoadingState } from "./interface";
import { IStoreRootState } from "@/store/interface";

export default <GetterTree<ILoadingState, IStoreRootState>> {
	isActive: ({ loadingCount }) => loadingCount !== 0
}